<div class="payment-iframe-shell" testId="payment-iframe-shell">
  <div class="payment-iframe-toolbar" testId="payment-iframe-toolbar">
    <div class="payment-iframe-heading" testId="payment-iframe-copy">
      <div class="payment-iframe-icon">
        <i nz-icon nzType="credit-card" nzTheme="outline"></i>
      </div>
      <div class="payment-iframe-title" testId="payment-iframe-title">{{ 'payment.iframe.title' | i18n }}</div>
      <div class="payment-iframe-desc" testId="payment-iframe-desc">{{ 'payment.iframe.desc' | i18n }}</div>
    </div>
    <div class="payment-iframe-actions" testId="payment-iframe-actions">
      <button nz-button type="button" (click)="openInNewWindow()" testId="payment-iframe-open-new-window-button">{{
        'payment.iframe.open-new-window' | i18n
      }}</button>
      <button nz-button type="button" (click)="close()" testId="payment-iframe-close-button">{{ 'common.close' | i18n }}</button>
    </div>
  </div>

  <iframe
    *ngIf="safePaymentUrl"
    class="payment-iframe"
    [attr.title]="'payment.iframe.frame-title' | i18n"
    [src]="safePaymentUrl"
    referrerpolicy="no-referrer-when-downgrade"
    testId="payment-iframe-frame"
  ></iframe>
</div>
